import { PRICING_TIERS } from '@/content/site-content';

/**
 * The dark pricing band.
 *
 * The numbers are deliberately absent: the commission model is open question
 * Q2 in DECISIONS.md, so this section says what shape the pricing will take and
 * labels itself a placeholder rather than inventing a fee.
 */
export function PricingSection() {
  return (
    <section id="pricing" className="scroll-mt-28 bg-ink py-16 lg:py-20">
      <div className="container-page">
        <h2 className="text-center text-3xl font-extrabold text-white sm:text-4xl">
          Simple, <span className="text-sun-400">Transparent</span> Pricing
          <span aria-hidden="true" className="ml-1 text-2xl text-sun-400">
            ✦
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-white/65">
          Our fee structure is still being finalized ahead of launch - this is a placeholder to show
          the shape of it.
        </p>

        <ul className="mt-12 grid items-start gap-5 lg:grid-cols-3">
          {PRICING_TIERS.map((tier) => (
            <li
              key={tier.audience}
              className={`rounded-[1.25rem] p-6 ${
                tier.featured ? 'bg-sun-400 text-ink lg:-mt-4 lg:pb-10' : 'bg-[#222222] text-white'
              }`}
            >
              {tier.flag && (
                <p className="mb-3 inline-block rounded-md bg-ink/15 px-2 py-1 text-[0.6rem] font-extrabold tracking-[0.08em]">
                  {tier.flag}
                </p>
              )}

              <p
                className={`text-[0.65rem] font-extrabold tracking-[0.12em] uppercase ${
                  tier.featured ? 'text-ink/70' : 'text-white/55'
                }`}
              >
                {tier.audience}
              </p>

              <h3
                className={`mt-2 text-2xl font-extrabold ${
                  tier.featured ? 'text-ink' : 'text-sun-400'
                }`}
              >
                {tier.headline}
              </h3>

              <ul className="mt-6 space-y-3">
                {tier.points.map((point) => (
                  <li
                    key={point}
                    className={`flex gap-2.5 text-sm leading-relaxed ${
                      tier.featured ? 'text-ink/85' : 'text-white/80'
                    }`}
                  >
                    <span aria-hidden="true">—</span>
                    {point}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>

        <p className="mt-10 text-center text-xs text-white/50">
          * Final pricing will be confirmed before public launch. This section is a placeholder.
        </p>
      </div>
    </section>
  );
}
